
export default {
    state: {
        userInfo:{}
    },

    mutations: {
        SET_USERINFO(state,data){
            state.userInfo = data;
            sessionStorage.setItem('userInfo',data.isAdmin);
        },
    },

    actions: {
        getUserinfo({commit},parms){
            commit('SET_USERINFO',parms)   
        },
    },
    namespaced: true
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js